export interface PostItem {
  id: number;
  title: string;
  category: string;
  excerpt: string;
  heat: number;
  likes: number;
  comments: number;
  tag: string;
}

export interface FeaturedItem {
  id: number;
  title: string;
  cover: string;
  category: string;
  excerpt: string;
  likes: number;
  comments: number;
  author: string;
  time: string;
}

// 今日热榜 Top 榜单
export const hotRank: PostItem[] = [
  { id: 1, title: "年度神仙打架舞台盘点：一开口全场起立的名场面合集", category: "综艺现场", excerpt: "网友票选今年最炸裂的三分钟舞台，现场镜头与弹幕一起封神。", heat: 99, likes: 38421, comments: 7214, tag: "高能现场" },
  { id: 2, title: "这部冷门好剧悄悄拿下了 8.9 分，为什么没人安利它？", category: "剧集热议", excerpt: "没有大咖流量，全靠剧本和演技口碑发酵的宝藏剧。", heat: 96, likes: 31205, comments: 5908, tag: "口碑剧" },
  { id: 3, title: "一档观察类综艺为什么让人越看越上头？拆解它的节奏密码", category: "综艺现场", excerpt: "从嘉宾选择到环节设计，聊聊这档节目让人追着看的底层逻辑。", heat: 92, likes: 27830, comments: 4860, tag: "深度拆解" },
  { id: 4, title: "综艺里最打动人的瞬间，往往不是高光而是这一句真话", category: "节目评论", excerpt: "盘点那些让网友集体破防、直呼「说到心坎」的真实表达。", heat: 89, likes: 25412, comments: 4021, tag: "走心时刻" },
  { id: 5, title: "这几档老牌综艺复播后口碑回春，情怀真的能救活节目吗？", category: "综艺现场", excerpt: "当熟悉的配方遇上新的观众，情怀牌还能打多久。", heat: 85, likes: 22097, comments: 3762, tag: "行业观察" },
  { id: 6, title: "年度「最会带节奏」的剪辑瞬间合集，笑到头掉的二创现场", category: "网络热议", excerpt: "网友剪刀手把节目剪出花，二创热度反哺正片的现象又来了。", heat: 82, likes: 19874, comments: 3308, tag: "爆笑二创" },
  { id: 7, title: "从造型到妆发：今年红毯谁最有「有效营业」的自觉？", category: "时尚八卦", excerpt: "红毯不仅是比美，更是比谁更懂「有效营业」。", heat: 79, likes: 18320, comments: 2965, tag: "红毯盘点" },
  { id: 8, title: "热门电影口碑两极分化，观众到底在吵什么？", category: "影视口碑", excerpt: "同一部电影，有人看得热泪盈眶，有人直呼看不懂。", heat: 75, likes: 15602, comments: 2744, tag: "口碑争议" },
];

// 高赞内容榜单（精华帖）
export const topPosts: PostItem[] = [
  { id: 1, title: "追了十期观察综艺，终于看懂导演藏的主线伏笔", category: "深度长文", excerpt: "一条弹幕里被网友发现的主线线索，越品越有味道。", heat: 97, likes: 35210, comments: 6288, tag: "神级解读" },
  { id: 2, title: "盘点那些年我们追过的综艺名场面，第一期就让我破防", category: "怀旧合集", excerpt: "从选秀到真人秀，这些名场面见证了一代人的综艺记忆。", heat: 93, likes: 30124, comments: 5520, tag: "回忆杀" },
  { id: 3, title: "三句话让节目组连夜改字幕，网友弹幕到底多有梗？", category: "网络热议", excerpt: "弹幕文化从观看体验升级为内容创作，这届网友太有才。", heat: 90, likes: 27615, comments: 4905, tag: "弹幕文化" },
  { id: 4, title: "为什么你总觉得别人的追剧片单更好看？聊聊算法与口味", category: "内容观察", excerpt: "被算法推荐包围的我们，如何找回「自己选片」的乐趣。", heat: 86, likes: 23480, comments: 4033, tag: "算法思考" },
  { id: 5, title: "这位宝藏歌手终于被看到了，请给他一个更大的舞台", category: "音乐现场", excerpt: "一句高音现场让无数观众原地入坑，全网求舞台直拍。", heat: 84, likes: 21908, comments: 3710, tag: "宝藏安利" },
  { id: 6, title: "热播剧里的这一场对手戏，值得写进表演教科书", category: "剧集热议", excerpt: "没有台词轰炸，全靠微表情与留白撑起的一整场戏。", heat: 80, likes: 18652, comments: 3155, tag: "演技鉴赏" },
];

// 主题分类（Tab 使用）
export const categories = ["综艺现场", "剧集热议", "网络热议", "音乐现场", "影视口碑"] as const;

// 分类精选内容池
export const collectionData: FeaturedItem[] = [
  {
    id: 1,
    title: "这档音综把「神仙打架」玩明白了，每一期都在刷新上限",
    cover: "https://readdy.ai/api/search-image?query=glowing%20concert%20stage%20with%20warm%20amber%20spotlights%20and%20silhouetted%20performers%2C%20dynamic%20bokeh%20lights%20in%20the%20background%2C%20editorial%20entertainment%20photography%2C%20cinematic%20atmosphere&width=1200&height=800&seq=gua-c-01&orientation=landscape",
    category: "综艺现场",
    excerpt: "从选曲到编曲层层升级，节目用诚意换来口碑与热度双丰收。",
    likes: 18420,
    comments: 3200,
    author: "追综艺的小A",
    time: "2026-09-05",
  },
  {
    id: 2,
    title: "被低估的现实题材好剧，把普通人的故事拍进了心里",
    cover: "https://readdy.ai/api/search-image?query=quiet%20cinematic%20drama%20scene%20with%20warm%20window%20light%20and%20soft%20shadows%2C%20cozy%20apartment%20interior%20mood%2C%20film%20grain%20texture%2C%20editorial%20television%20drama%20photography&width=1200&height=800&seq=gua-c-02&orientation=landscape",
    category: "剧集热议",
    excerpt: "没有悬浮的剧情，只有扎实的人物与真实的日常，后劲十足。",
    likes: 16880,
    comments: 2875,
    author: "看剧很认真",
    time: "2026-09-04",
  },
  {
    id: 3,
    title: "热搜之外，还有哪些被忽略却值得一看的网络好内容？",
    cover: "https://readdy.ai/api/search-image?query=colorful%20trending%20topic%20mosaic%20wall%20with%20floating%20speech%20bubbles%20and%20social%20media%20icons%2C%20vibrant%20orange%20and%20pink%20palette%2C%20modern%20digital%20art%20collage%2C%20playful%20editorial%20illustration&width=1200&height=800&seq=gua-c-03&orientation=landscape",
    category: "网络热议",
    excerpt: "在算法洪流里，给「慢内容」一点耐心，你会发现更多惊喜。",
    likes: 14530,
    comments: 2010,
    author: "冲浪观察员",
    time: "2026-09-03",
  },
  {
    id: 4,
    title: "Live 现场的感染力无法替代：年度巡演高光瞬间全记录",
    cover: "https://readdy.ai/api/search-image?query=energetic%20live%20music%20concert%20crowd%20with%20raised%20hands%20and%20colorful%20stage%20lights%2C%20smoke%20and%20laser%20beams%2C%20festival%20atmosphere%2C%20candid%20editorial%20photography&width=1200&height=800&seq=gua-c-04&orientation=landscape",
    category: "音乐现场",
    excerpt: "耳机里的感动，只有走进 Livehouse 才能真正听懂。",
    likes: 13210,
    comments: 1845,
    author: "现场党小李",
    time: "2026-09-02",
  },
  {
    id: 5,
    title: "这部被票房低估的电影，正在靠口碑一点点翻盘",
    cover: "https://readdy.ai/api/search-image?query=moody%20cinema%20poster%20style%20backdrop%20with%20warm%20and%20cool%20contrast%20lighting%2C%20film%20reel%20and%20popcorn%20silhouette%2C%20artistic%20movie%20appreciation%20editorial%20photography&width=1200&height=800&seq=gua-c-05&orientation=landscape",
    category: "影视口碑",
    excerpt: "首周票房平平，却在社交平台被自来水推荐到逆袭。",
    likes: 12090,
    comments: 1660,
    author: "电影院常客",
    time: "2026-09-01",
  },
  {
    id: 6,
    title: "同样是搞笑综艺，为什么这一档能让人笑到最后一秒？",
    cover: "https://readdy.ai/api/search-image?query=playful%20comedy%20variety%20show%20set%20with%20bright%20colorful%20props%20and%20confetti%2C%20cheerful%20ambience%2C%20warm%20sunny%20tones%2C%20fun%20entertainment%20editorial%20photography&width=1200&height=800&seq=gua-c-06&orientation=landscape",
    category: "综艺现场",
    excerpt: "好的综艺让人忘记时间，这一档做到了：笑点密集不掉线。",
    likes: 11230,
    comments: 1430,
    author: "下饭必备君",
    time: "2026-08-31",
  },
];

// 主编精选（详情展示）
export const editorPick = {
  id: 1,
  category: "主编精选",
  title: "年度高赞内容 TOP20 合集：这 20 条「瓜」，条条值得反复回味",
  subtitle: "从一档节目的一句话，到一群人的集体共鸣",
  cover: "https://readdy.ai/api/search-image?query=warm%20sunset%20over%20city%20skyline%20with%20golden%20and%20orange%20tones%2C%20abstract%20watermelon%20slice%20texture%20in%20soft%20focus%20foreground%2C%20summer%20vibes%2C%20magazine%20cover%20aesthetic%2C%20cinematic%20lighting&width=1600&height=900&seq=gua-editor-01&orientation=landscape",
  body: [
    "把全年热度最高、口碑最好、讨论最深的优质内容放进同一份片单，是我们做这份年度合集的初衷。它不追求「量」，而看重「回味」。",
    "我们反复比对用户讨论热度、观点含金量与二创传播度，从数千条内容里筛选出这 20 条。它们跨越综艺现场、剧集热议、网络热议与音乐现场，却有一个共同点：都在某个时刻，精准击中了观众的情绪。",
    "有网友说，好的内容就像夏天的第一口西瓜，清甜又解渴。我们希望这份合集，能成为你通勤、午休、睡前的「饭后甜点」，让碎片时间不再被无效信息填满。",
    "当然，榜单只是一份参考。真正的「吃瓜自由」，是你拥有判断与挑选的能力。所以我们也刻意收录了几条观点相左的内容——热闹之外，也请保留一点冷静。",
    "最后，感谢每一位在评论区认真分享的人。是你们的讨论，让这些内容从「看过」变成了「值得一看」。期待明年，我们再见。",
  ],
  author: "吃瓜大全 主编",
  date: "2026-09-06",
  readMinutes: 6,
};

// FAQ
export const faqs: { q: string; a: string }[] = [
  { q: "「吃瓜大全」的内容是怎么挑选出来的？", a: "我们会综合讨论热度、观点含金量、互动量与二创传播度，人工结合数据从全网综艺、剧集、音乐与热议话题中筛选，优先收录有信息增量与讨论价值的精华内容，而非单纯追逐热搜流量。" },
  { q: "这里的「精华帖」和普通热搜有什么不同？", a: "热搜反映的是「当下最热」，而精华帖更看重「值得看」。我们会回溯长期口碑与讨论深度，把那些过去几天甚至几周仍被人反复提起、值得回味的优质内容整理成合集，避免你错过真正的精品。" },
  { q: "高赞内容会不会有刷赞或营销成分？", a: "我们会剔除明显的营销号、批量灌水与恶意引战内容，并交叉核验多个讨论平台的反馈。榜单仍以真实用户讨论为基准，出现争议时会标注说明，尽量还原客观讨论生态。" },
  { q: "更新频率是怎样的？", a: "「今日热榜」每日更新，「高赞内容」与「主题分类合集」每周更新，「主编精选」与年度盘点按节点发布。你可以在页面底部订阅，第一时间收到精选合集推送。" },
  { q: "我能投稿或推荐内容吗？", a: "当然可以。如果你发现值得上墙的综艺名场面、好剧或热议话题，欢迎通过订阅邮箱或评论区与我们联系，我们会认真阅读每一条推荐。" },
  { q: "收录内容会有版权问题吗？", a: "本站以聚合、索引与观点分享为主，仅展示标题、简介与外部讨论入口，引导用户回到原平台观看，尊重内容创作者与版权方的权益。" },
];

// 口碑评价
export const testimonials: { name: string; role: string; text: string; rating: number }[] = [
  { name: "午后刷瓜的Momo", role: "综艺爱好者", text: "每天午饭后的固定节目，先看今日热榜再决定晚上追哪期，帮我省了很多找内容的功夫。", rating: 5 },
  { name: "下饭剧研究所", role: "追剧十年选手", text: "主编精选的合集质量真的高，好几部冷门好剧都是在这里被安利到的，从不踩雷。", rating: 5 },
  { name: "弹幕区扛把子", role: "重度冲浪用户", text: "高赞内容榜比我自己刷热搜效率高多了，观点也更有信息量，评论区的讨论氛围很舒服。", rating: 4 },
  { name: "屏幕前的老观众", role: "电视节目迷", text: "喜欢这种不做作的内容整理，不标题党不引战，就是踏踏实实把好内容挑给你。", rating: 5 },
];

// 页脚栏目
export const footerColumns: { title: string; links: string[] }[] = [
  { title: "精选板块", links: ["今日热榜", "高赞内容", "精华帖合集", "主题分类"] },
  { title: "热点频道", links: ["综艺现场", "剧集热议", "音乐现场", "影视口碑"] },
  { title: "关于我们", links: ["品牌介绍", "口碑评价", "常见问题", "加入收藏"] },
];